var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPresentation = function SvgPresentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".presentation_svg__st1{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z",
    id: "presentation_svg__bounding_box"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "presentation_svg__design"
  }, /*#__PURE__*/React.createElement("path", {
    className: "presentation_svg__st1",
    d: "M20 9.03v10.94c0 .57-.46 1.03-1.03 1.03h-1.94c-.57 0-1.03-.46-1.03-1.03V9.03c0-.57.46-1.03 1.03-1.03h1.94c.57 0 1.03.46 1.03 1.03zM14 5.17v14.66c0 .64-.53 1.17-1.17 1.17h-1.66c-.64 0-1.17-.53-1.17-1.17V5.17c0-.64.53-1.17 1.17-1.17h1.66c.64 0 1.17.53 1.17 1.17zM8 12.85v7.3c0 .47-.38.85-.85.85h-2.3a.85.85 0 0 1-.85-.85v-7.3c0-.47.38-.85.85-.85h2.3c.47 0 .85.38.85.85z"
  }))));
};

export default SvgPresentation;